var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "menu-container pa-2",
      style: {
        left: _vm.horizontal + "px",
        top: _vm.vertical + "px",
        backgroundColor: "white"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex align-center pa-2 rack-menu-item",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClick("edit")
            }
          }
        },
        [
          _c("v-icon", { staticClass: "rack-menu-icon" }, [_vm._v("create")]),
          _vm._v(" "),
          _c("p", { staticClass: "rack-menu-option" }, [_vm._v("Edit Rack")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-center pa-2 rack-menu-item",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.handleClick("delete")
            }
          }
        },
        [
          _c("v-icon", { staticClass: "rack-menu-icon" }, [_vm._v("delete")]),
          _vm._v(" "),
          _c("p", { staticClass: "rack-menu-option" }, [_vm._v("Delete Rack")])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db15ad08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db15ad08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/menus/RackOptionsMenu.vue
// module id = null
// module chunks = 